export default __webpack_public_path__ + "static/media/amaze.e43163b1.gif";